import Store from "../../../../Store"

export const getExpertName = (languagePair) => {
    return Store.getText("expert")
}
